import { createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';
import { User } from './user.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface UsersState {
    users: User[];
    user: User | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialUsersState: UsersState = {
    users: [],
    user: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Users Reducer
export const usersReducer = createReducer(
    initialUsersState,

    // On Load Users
    on(UserActions.loadUsers, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(UserActions.loadUsersSuccess, (state, { users }) => ({
        ...state,
        isLoading: false,
        users: users,
    })),
    on(UserActions.loadUsersFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Users
    on(UserActions.loadUser, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(UserActions.loadUserSuccess, (state, { user }) => ({
        ...state,
        isLoading: false,
        user: user,
    })),
    on(UserActions.loadUserFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create User
    on(UserActions.createUser, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(UserActions.createUserSuccess, (state, { user }) => ({
        ...state,
        isLoading: false,
        users: [...(state.users || []), user],
    })),
    on(UserActions.createUserFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(UserActions.updateUser, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(UserActions.updateUserSuccess, (state, { user }) => ({
        ...state,
        isLoading: false,
        users: state.users.map((u) => (u.id === user.id ? user : u)),
        user: user,
    })),
    on(UserActions.updateUserFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(UserActions.deleteUser, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(UserActions.deleteUserSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        users: state.users.filter((user) => user.id !== id),
    })),
    on(UserActions.deleteUserFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Toggle User Status
    on(UserActions.toggleUserStatus, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(UserActions.toggleUserStatusSuccess, (state, { user }) => ({
        ...state,
        isLoading: false,
        users: state.users.map((u) => (u.id === user.id ? user : u)),
    })),
    on(UserActions.toggleUserStatusFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
